import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import filter from 'lodash/filter';

import themeable from 'zignal-landscape/lib/themeable';
import Button from 'zignal-landscape/lib/Button';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import FilterShowIcon from 'zignal-landscape/lib/Icon/FilterShowIcon';
import DisplayOptions from '../../components/DisplayOptions';
import TopClustersByVolume from '../../components/TopClustersByVolume';

import * as actions from '../../BotIntelligence.ducks';
import {
  SIZE_NODES_BY_OPTIONS,
  VIEW_BY_OPTIONS
} from '../../constants';

const mapStateToProps = (
  (state) => ({
    isClusterMenuButtonOpen: state.BotIntelligence.Page.isClusterMenuButtonOpen,
    isMenuPanelOpen: state.BotIntelligence.Page.isMenuPanelOpen,
    selectedSizeNodeByOption: state.BotIntelligence.Page.selectedSizeNodeByOption,
    selectedTopClustersByVolume: state.BotIntelligence.Page.selectedTopClustersByVolume,
    selectedViewByOption: state.BotIntelligence.Page.selectedViewByOption,
    showSelectionOnly: state.BotIntelligence.Page.showSelectionOnly,
    filteredClusterNodes: state.BotIntelligence.Page.filteredClusterNodes,
    viewBy: state.BotIntelligence.Page.viewBy,
    lastSearchBy: state.BotIntelligence.Page.lastSearchBy,
    filteredAutomationScore: state.BotIntelligence.Page.filteredAutomationScore,
    profileIds: state.BotIntelligence.SearchFilters.profileIds
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

const ActionsMenuPanel = (props) => {
  const {
    styles,
    isClusterMenuButtonOpen,
    isMenuPanelOpen,
    selectedSizeNodeByOption = {},
    selectedTopClustersByVolume,
    selectedViewByOption = {},
    filteredClusterNodes,
    showSelectionOnly,
    viewBy,
    lastSearchBy,
    filteredAutomationScore,
    profileIds = [],
    // passed by parent
    isUserDiscoverFeatureEnabled,
    clusterNodes = [],
    setMenuBulkActionsRef,
    additionalFilterOptions,
    // actions
    toggleShowSelectionOnly,
    setSelectedSizeNodesByOption,
    toggleViewByOption,
    setSelectedViewByOption,
    setAddToGroupModalVisibility,
    toggleMenuPanelVisibility,
    setClusterMenuButtonVisibility,
    searchDiscover,
    selectClusters,
    setfilteredClusterNodes,
    clearSelection,
    setGraphHoverFromList,
    filterAutomationScore,
    toggleUnknownFilter,
  } = props;

  const clusterBy = selectedViewByOption.value;
  const viewByOptions = (viewBy === 'category') ? VIEW_BY_OPTIONS.byCategory : VIEW_BY_OPTIONS.byCluster;

  let filteredViewByOptions = (lastSearchBy === 'profiles')
    ? filter(viewByOptions, ({isProfileSearchEnabled}) => isProfileSearchEnabled !== false)
    : filter(viewByOptions, ({isKeywordSearchEnabled}) => !!isKeywordSearchEnabled);

  // Sentiment is disabled for multiple profiles searches.
  if (lastSearchBy === 'profiles' && profileIds.length > 1) {
    filteredViewByOptions = filter(filteredViewByOptions, ({value}) => value !== 'sentiment');
    // Reset selected value when current one is not available anymore.
    if (selectedViewByOption.value === 'sentiment') {
      setSelectedViewByOption(filteredViewByOptions[0]);
    }
  }

  return isMenuPanelOpen === false ?
    <div className={styles.panelMargin}>
      <ToolTip position="right" tooltipText="Show Display Options and Top Clusters by volume">
        <Button icon={<FilterShowIcon />} onClick={toggleMenuPanelVisibility} />
      </ToolTip>
    </div> :
    <div className={classnames(styles.ActionsMenuPanel, styles.panelMargin)}>
      <DisplayOptions
        additionalFilterOptions={additionalFilterOptions}
        selectedSizeNodeByOption={selectedSizeNodeByOption}
        selectedViewByOption={selectedViewByOption}
        selectClusters={selectClusters}
        filteredClusterNodes={filteredClusterNodes}
        setSelectedSizeNodesByOption={setSelectedSizeNodesByOption}
        setSelectedViewByOption={setSelectedViewByOption}
        toggleViewByOption={toggleViewByOption}
        setfilteredClusterNodes={setfilteredClusterNodes}
        sizeNodesByOptions={SIZE_NODES_BY_OPTIONS}
        viewBy={viewBy}
        filteredViewByOptions={filteredViewByOptions}
        toggleMenuPanelVisibility={toggleMenuPanelVisibility}
        lastSearchBy={lastSearchBy}
        filteredAutomationScore={filteredAutomationScore}
        filterAutomationScore={filterAutomationScore}
        toggleUnknownFilter={toggleUnknownFilter}
      />
      <div className={styles.menuPanelThematicBreak} />
      <TopClustersByVolume
        clusterBy={clusterBy}
        clusterNodes={clusterNodes}
        isMenuButtonOpen={isClusterMenuButtonOpen}
        isUserDiscoverFeatureEnabled={isUserDiscoverFeatureEnabled}
        searchDiscover={searchDiscover}
        clearSelection={clearSelection}
        selectClusters={selectClusters}
        selectedClusters={selectedTopClustersByVolume}
        setClusterMenuButtonVisibility={setClusterMenuButtonVisibility}
        setMenuBulkActionsRef={setMenuBulkActionsRef}
        showSelectionOnly={showSelectionOnly}
        toggleShowSelectionOnly={toggleShowSelectionOnly}
        setAddToGroupModalVisibility={setAddToGroupModalVisibility}
        titleLabel={selectedViewByOption.label}
        isSearchDiscoverDisabled={!selectedViewByOption.searchPattern}
        setGraphHoverFromList={setGraphHoverFromList}
      />
    </div>;
};

ActionsMenuPanel.propTypes = {
  styles: PropTypes.object,
  isClusterMenuButtonOpen: PropTypes.bool,
  isMenuPanelOpen: PropTypes.bool,
  selectedSizeNodeByOption: PropTypes.object,
  selectedTopClustersByVolume: PropTypes.array,
  selectedViewByOption: PropTypes.object,
  showSelectionOnly: PropTypes.bool,
  viewBy: PropTypes.string,
  lastSearchBy: PropTypes.string,
  filteredAutomationScore: PropTypes.object,
  profileIds: PropTypes.array,
  additionalFilterOptions: PropTypes.array,
  filteredClusterNodes: PropTypes.object,
  // passed by parent
  clusterNodes: PropTypes.array,
  isUserDiscoverFeatureEnabled: PropTypes.bool,
  setMenuBulkActionsRef: PropTypes.func,

  // actions
  toggleShowSelectionOnly: PropTypes.func,
  setfilteredClusterNodes: PropTypes.func,
  setSelectedSizeNodesByOption: PropTypes.func,
  toggleViewByOption: PropTypes.func,
  setSelectedViewByOption: PropTypes.func,
  setAddToGroupModalVisibility: PropTypes.func,
  toggleMenuPanelVisibility: PropTypes.func,
  setClusterMenuButtonVisibility: PropTypes.func,
  searchDiscover: PropTypes.func,
  selectClusters: PropTypes.func,
  clearSelection: PropTypes.func,
  setGraphHoverFromList: PropTypes.func,
  filterAutomationScore: PropTypes.func,
  toggleUnknownFilter: PropTypes.func,
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(ActionsMenuPanel));
